// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Qd-z","image":"Rd-z","imageNoBackground":"Sd-z"};